<script setup lang="ts">
import { computed } from 'vue'
import SelectSimple from '@/components/common/selects/SelectSimple.vue'

// The parent expects an object { year: number } | null in v-model.
const model = defineModel<{ year: number } | null>()

const numericYear = computed<number | string>({
  get: () => {
    return model.value?.year ?? new Date().getFullYear()
  },
  set: (val: number | string) => {
    model.value = { year: Number(val) }
  },
})

const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear()
  const options = []
  for (let i = currentYear - 5; i <= currentYear + 3; i++) {
    options.push({
      id: i,
      value: i,
      label: i.toString(),
    })
  }
  return options
})
</script>

<template>
  <SelectSimple v-model="numericYear" :options="yearOptions" />
</template>
